import React from 'react';

const CustomerService = () => {
  return (
    <div>
      <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-6 font-handwritten">Customer Service</h1>
      <div className="space-y-6 text-gray-700 dark:text-gray-300">
        <section>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Contact Information</h3>
          <p className="mb-4 text-gray-600 dark:text-gray-300">
            At Ry&apos;s Circus, we&apos;re committed to providing exceptional customer service. Our team is here to assist you with any questions, concerns, or feedback you may have about our products or services.
          </p>
          
          <div className="mt-4">
            <div className="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg">
              <h4 className="font-medium text-gray-900 dark:text-white mb-2">Email Support</h4>
              <p><a href="mailto:support@ryscircus.com" className="text-blue-600 dark:text-blue-400 hover:underline">support@ryscircus.com</a></p>
              <p className="text-sm mt-1">Response time: Within 24 hours</p>
            </div>
          </div>
        </section>
        
        <section>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Contact Form</h3>
          <p>You can also reach us through our online contact form:</p>
          
          <form className="mt-4 space-y-4">
            <div>
              <label htmlFor="name" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Name</label>
              <input type="text" id="name" name="name" className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-gray-800 dark:border-gray-600 dark:text-white" />
            </div>
            
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Email</label>
              <input type="email" id="email" name="email" className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-gray-800 dark:border-gray-600 dark:text-white" />
            </div>
            
            <div>
              <label htmlFor="order" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Order Number (if applicable)</label>
              <input type="text" id="order" name="order" className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-gray-800 dark:border-gray-600 dark:text-white" />
            </div>
            
            <div>
              <label htmlFor="message" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Message</label>
              <textarea id="message" name="message" rows="4" className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-gray-800 dark:border-gray-600 dark:text-white"></textarea>
            </div>
            
            <div>
              <button
                type="submit"
                className="w-full bg-purple-600 hover:bg-purple-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline transition duration-150 ease-in-out"
              >
                Send Message
              </button>
              <p className="text-xs text-gray-500 dark:text-gray-400 mt-2">
                We&apos;ll respond to your inquiry within 24-48 business hours.
              </p>
            </div>
          </form>
        </section>
        
        <section>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Business Hours</h3>
          <p>Our customer service team is available to assist you during the following hours:</p>
          <p className="mt-2">Monday-Friday: 9am-5pm EST</p>
          <p>Saturday-Sunday: Closed</p>
          <p className="mt-2 text-sm">Please note that response times may be longer during weekends and holidays.</p>
        </section>
        
        <section>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Response Time</h3>
          <p>We strive to respond to all inquiries within 24 hours during business days. For urgent matters, please contact us by email.</p>
        </section>
      </div>
    </div>
  );
};

export default CustomerService;
